import React from "react";

const XSvg = () => {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>X</title>
			<path
				d="M10.9148 0.846802H13.0023L8.44151 6.05974L13.8071 13.1532H9.60576L6.31532 8.85093L2.5502 13.1532H0.461258L5.33951 7.57743L0.192383 0.846802H4.50013L7.47451 4.77911L10.9148 0.846802ZM10.182 11.9036H11.3389L3.87163 2.0308H2.63038L10.182 11.9036Z"
				fill="white"
				className="fill-white dark:fill-darkCardBg"
			/>
		</svg>
	);
};

export default XSvg;
